// removed by extract-text-webpack-plugin
module.exports = {"pageHeader":"pageHeader___Xq1bF","detail":"detail___3H8YM","row":"row___3I9Cn","breadcrumb":"breadcrumb___17l5_","tabs":"tabs___x9Jqa","logo":"logo___28K6_","title":"title___1F8vO","action":"action___19lAi","content":"content___3Ft3i","extraContent":"extraContent___3-usJ","main":"main___3g9Dm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ant-design-pro/PageHeader/index.less
// module id = 0GVH
// module chunks = 15 16 17 20 21 28 41 42 43 44 45 46 47 48